(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["design-blog"] && !Shopify.designMode) return;
  try {
    

  var $grid = $('.article-grid');

$grid.imagesLoaded(function(){
  $grid.masonry({
    itemSelector: '.article-block',
  columnWidth: '.article-block',
  percentPosition: true,
  gutter: '.gutter-sizer'
  });
});








  






  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    

  var $grid = $('.gallery-grid');

$grid.imagesLoaded(function(){
  $grid.masonry({
    itemSelector: '.gallery-block',
  columnWidth: '.gallery-block',
  percentPosition: true,
  gutter: '.gutter-sizer',
    horizontalOrder: true
  });
});

 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  $('#shop-open').on('mouseover', function() {
    $('.shop-dropdown-border').addClass('show');
  });

$('#shop-open').on('mouseout', function() {
    
    $('.shop-dropdown-border').removeClass('show');
    
  });
  

  $('#shop-dropdown').on('mouseover', function() {
    $('.shop-dropdown-border').addClass('show');
  });

  
  $('#shop-dropdown').on('mouseout', function() {
    $('.shop-dropdown-border').removeClass('show');
  });


  $('.header .icon-hamburger').on('click', function() {
    $('.header').addClass('darkbg');
  });

  $('.header .icon-close').on('click', function() {
    $('.header').removeClass('darkbg');
  });

  $('.header .shop-open').on('mouseover', function() {
    $('.header').addClass('lightbg');
  });

  $('.header .shop-open').on('mouseout', function() {
    $('.header').removeClass('lightbg');
  });

  $('#shop-dropdown').on('mouseover', function() {
    $('.header').addClass('lightbg');
  });

  
  $('#shop-dropdown').on('mouseout', function() {
    $('.header').removeClass('lightbg');
  });

  

  
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-recent-blogs"] && !Shopify.designMode) return;
  try {
    


  
         
var imgs = $('.article-image img');//jQuery class selector
    imgs.each(function(){
      var img = $(this);
      var imgClass = $(this).attr('class');
      var width = img.width(); //jQuery width method
      var height = img.height(); //jQuery height method
      if(width < height){
         $(this).addClass('portrait');
        var artBlock = $('.article-block');
        artBlock.each(function(){
          if($(this).hasClass(imgClass)){
          $(this).addClass('portrait');
        }
        })
        
      }else{
         $(this).addClass('landscape');
        var artBlock = $('.article-block');
        artBlock.each(function(){
          if($(this).hasClass(imgClass)){
          $(this).addClass('landscape');
        }
        })
        
      }
  });


  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-shop-menu"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function(){
  document.querySelector(".hp-shop-menu").addEventListener("mousemove", function(e) {
    let elem = document.querySelector(".hp-shop-menu .menu-container");
    let rect = elem.getBoundingClientRect();
    var moveX = e.clientX;
    var moveY = e.clientY - rect.top;
    $('.hp-shop-menu .menu-block img').css('left',moveX+"px");
    $('.hp-shop-menu .menu-block img').css('top',moveY+"px");
  });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifestyle-blog"] && !Shopify.designMode) return;
  try {
    


  var $grid = $('.article-grid-lifestyle');

  

$grid.imagesLoaded(function(){
  $grid.masonry({
    itemSelector: '.article-block',
  columnWidth: '.article-block',
  percentPosition: true,
  gutter: '.gutter-sizer'
  });
});





  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  
  document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate();
});
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

  document.addEventListener('DOMContentLoaded', function () {
  const triggers = document.querySelectorAll('.collapsible__trigger');

  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const container = trigger.closest('.collapsible');
      container.classList.toggle('active');
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sourcebook-product"]) return;
  try {
    

  document.addEventListener('DOMContentLoaded', function () {
  const triggers = document.querySelectorAll('.collapsible__trigger');

  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const container = trigger.closest('.collapsible');
      container.classList.toggle('active');
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["travel-blog"] && !Shopify.designMode) return;
  try {
    


  var $grid = $('.article-grid-travel');

$grid.imagesLoaded(function(){
  $grid.masonry({
    itemSelector: '.article-block',
  columnWidth: '.article-block',
  percentPosition: true,
  gutter: '.gutter-sizer'
  });
});






  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vintage-blog"] && !Shopify.designMode) return;
  try {
    


  var $grid = $('.article-grid-vintage');

$grid.imagesLoaded(function(){
  $grid.masonry({
    itemSelector: '.article-block',
  columnWidth: '.article-block',
  percentPosition: true,
  gutter: '.gutter-sizer'
  });
});



  

  } catch(e) { console.error(e); }
})();
})();
